import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config} from '../../shared';
import { CmsNotificationSchedulerContainer } from '../../../../../../models';

@Injectable({providedIn: 'root'})
export class CmsNotificationSchedulerService extends BaseApiTemplateService<CmsNotificationSchedulerContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + "notification-schedulers/" + Core2Config.BACKOFFICE_EP_SUFFIX;
  endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + "notification-schedulers/" + Core2Config.BACKOFFICE_EP_SUFFIX;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + "notification-schedulers/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + "notification-schedulers/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }
}